import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { announceRefreshAuth } from '@customerio/hydra-nav-state';

export default class SettingsAccountEditController extends Controller {
  @service alerts;
  @service router;
  @service hydra;

  @action
  cancel() {
    this.router.transitionTo('settings.account');
  }

  @action
  submit(attrs) {
    this.model.setProperties(attrs);

    return this.model.save().then(() => {
      // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
      if (this.hydra.isHydraEnabled) {
        announceRefreshAuth();
      }

      this.alerts.success('account.edit.success', 'Changes saved');

      this.router.transitionTo('settings.account');
    });
  }
}
